(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ser-native-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ser-native-size')) {
  customElements.define('ser-native-size', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('.ser-native-size-open');
      if (!this.dialog || !this.trigger) return;
      this.trigger.addEventListener('click', () => { if (!this.dialog.open) this.dialog.showModal(); });
      this.querySelector('.ser-native-size-close').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', e => {
        if (e.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) this.dialog.close();
      });
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      const activate = tab => this.tabs.forEach(t => {
        const active = t === tab;
        t.setAttribute('aria-selected', String(active));
        t.tabIndex = active ? 0 : -1;
        this.querySelector('[id="' + t.getAttribute('aria-controls') + '"]').hidden = !active;
      });
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', e => {
          let index;
          if (e.key === 'ArrowRight') index = (i + 1) % this.tabs.length;
          if (e.key === 'ArrowLeft') index = (i + this.tabs.length - 1) % this.tabs.length;
          if (e.key === 'Home') index = 0;
          if (e.key === 'End') index = this.tabs.length - 1;
          if (index === undefined) return;
          e.preventDefault(); activate(this.tabs[index]); this.tabs[index].focus();
        });
      });
      const convert = unit => {
        const source = this.dataset.sourceUnit === 'cm' ? 'cm' : 'inch';
        const factor = source === unit ? 1 : unit === 'cm' ? 2.54 : 1 / 2.54;
        this.querySelectorAll('[data-measurement]').forEach(cell => {
          const raw = cell.dataset.measurement;
          cell.textContent = raw.replace(/\d+(?:\.\d+)?/g, n => (Number(n) * factor).toFixed(1));
        });
        this.querySelectorAll('[data-display-unit]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.displayUnit === unit)));
      };
      this.querySelectorAll('[data-display-unit]').forEach(b => b.addEventListener('click', () => convert(b.dataset.displayUnit)));
      convert('inch');
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
